<template>
  <div id="bar-chart">
    <div class="rose-chart-title">一周整体OEE</div>
    <dv-charts :option="option" />
  </div>
</template>

<script>
export default {
  name: "barChart",
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      datas: this.beans,
      option: {},
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.datas = val;
        this.createData();
      },
      deep: true,
    },
  },
  methods: {
    createData() {
      var data = this.datas;

      const xAxis = [];
      const lineData = [];
      const lineKpi = [];
      data.forEach((item) => {
        xAxis.push(item.week);
        lineData.push(parseInt(item.oee));
        lineKpi.push(item.kpi);
      });

      this.option = {
        grid: {
          right: "0",
          left: "10%",
          top: "10%",
        },
        xAxis: {
          name: "WK", // 给X轴加单位
          nameLocation: "start",
          nameGap: 25,
          data: xAxis,
          axisLabel: {
            style: {
              fill: "#fff", // 坐标值得具体的颜色
            },
          },
          axisTick: {
            style: {
              stroke: "#fff", // 坐标值得具体的颜色
            },
          },
        },
        yAxis: [
          {
            name: "目标",
            data: "value",
            min: 0,
            max: 100,
            interval: 20,
            nameTextStyle: {
              fill: "#ffffff",
              fontSize: 12,
            },
            axisLabel: {
              formatter: "{value}",
              style: {
                fill: "#fff", // 坐标值得具体的颜色
              },
            },
            splitLine: {
              style: {
                lineDash: [3, 3],
              },
            },
          },
        ],
        series: [
          {
            data: lineData,
            type: "bar",
            gradient: {
              color: ["#37a2da", "#67e0e3"],
            },
          },
          {
            data: lineKpi,
            type: "line",
            lineStyle: {
              lineWidth: 3,
              stroke: "#ff0000",
            },
          },
        ],
      };
    },
  },
  mounted() {
    //const { createData } = this
    //this.createData()
    // setInterval(createData, 30000)
  },
};
</script>

<style lang="less">
#bar-chart {
  width: 20%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;

  .rose-chart-title {
    height: 50px;
    font-weight: bold;
    text-indent: 20px;
    font-size: 20px;
    display: flex;
    align-items: center;
  }

  .dv-charts-container {
    height: calc(~"100% - 50px");
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/oee/component/barChart.vue